import ExchangeAddressPage from './ExchangeAddressPage'
export default ExchangeAddressPage
